import React from 'react';
import { useSelector } from 'react-redux';
import HeaderDropdown from '../../Components/Header/HeaderDropdown/HeaderDropdown';
import ProjectPickerItem from './ProjectPickerItem';
import { useProjects } from '../../../../hooks/useProjects';
import { selectAuthenticationContext } from '../../../../selectors';
import { Link } from '@mui/material';
import { ViewAllDiv } from './ProjectPicker.styles';
import { getLandingPageUrl } from '../../../../utils';
import { useGlobalization } from '../../../../contexts';

const ProjectPicker = () => {
	const { t } = useGlobalization();
	const { alternativeProjects, activeProject } = useProjects();
	const { defaultSite, defaultSiteName } = useSelector(
		selectAuthenticationContext,
	);

	const Menu = alternativeProjects.map(project => (
		<ProjectPickerItem
			key={`${project.name}-${project.hubRegion}`}
			project={project}
		/>
	));

	if (Menu.length) {
		Menu.unshift(
			<ViewAllDiv key="view-all-projects">
				<Link
					target="_blank"
					rel="noopener noreferrer"
					href={getLandingPageUrl()}>
					{t('View All')}
				</Link>
			</ViewAllDiv>,
		);
	}

	return (
		<HeaderDropdown
			cy="project-picker"
			text={activeProject?.name ?? defaultSiteName ?? defaultSite ?? ''}
			anchorOrigin="center"
			list={Menu}
		/>
	);
};

export default ProjectPicker;
